export default __webpack_public_path__ + "static/media/img-3.f2ae8cd1.jpg";